import slice from "./dashboardSlice";

export default slice.reducer;
